import { commonParser } from './apiParser.helpers'
import { getSupportedLanguages } from './translation.helpers'
import { requiredRule } from './validation.helpers'

const formatSurveysToObject = (surveys) => {
  if (surveys && surveys.length) {
    return surveys.reduce((obj, data) => {
      const survey = commonParser(data)
      return survey && survey.id
        ? {
            ...obj,
            [survey.id]: survey
          }
        : {}
    }, {})
  }
  return {}
}

const formatUserSurveysToObject = (userSurveys) => {
  if (userSurveys && userSurveys.length) {
    return userSurveys.reduce((obj, userSurvey) => {
      const surveyId = userSurvey?.survey_id
      return surveyId
        ? {
            ...obj,
            [surveyId]: {
              id: userSurvey?.id,
              response: { ...userSurvey.response, ...obj?.[surveyId]?.response }
            }
          }
        : {}
    }, {})
  }
  return {}
}

const formatUserSurveyToObject = (userSurvey) => {
  if (userSurvey) {
    const { id, survey_id, response } = userSurvey
    return {
      surveyId: survey_id,
      id,
      response
    }
  }
  return {}
}

const extractSurveyQuestions = (survey, language) => {
  const supportedLanguages = getSupportedLanguages()
  return survey?.questions[language] || survey?.questions[supportedLanguages[0]]
}

const buildCreateUserSurveyData = (surveyId, response) => {
  return {
    user_survey: {
      response,
      survey_id: surveyId
    }
  }
}

const buildUpdateUserSurveyData = ({ surveyId, response }, state) => {
  const userSurvey = extractSurveyProfileState(state).userSurveys?.[surveyId]
  return {
    user_survey: {
      response: {
        ...userSurvey.response,
        ...response
      }
    }
  }
}

const buildCheckValidationRules = (surveyFields, formData) => {
  const validations = {}
  if (surveyFields && surveyFields.length > 0) {
    surveyFields.forEach(({ id, required }) => {
      const value = formData?.[id] || ''
      validations[id] = {
        value,
        rules: [required && requiredRule]
      }
    })
  }
  return validations
}

const extractSurveyReducer = (state) => state.value.surveyReducer

const extractSurveyProfileState = (state) => {
  return extractSurveyReducer(state).surveyProfile
}

export {
  formatSurveysToObject,
  formatUserSurveysToObject,
  formatUserSurveyToObject,
  extractSurveyQuestions,
  buildCheckValidationRules,
  buildCreateUserSurveyData,
  buildUpdateUserSurveyData,
  extractSurveyProfileState
}
